var emailInput;
var main_error = `
   <span class="visually-hidden">Error</span>
  <span class="form__message">
    <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
      <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
      <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
      <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
      <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
      </path>
    </svg>
    Email is invalid</span>`
$("#ContactForm-email").on("change", function() {
  emailInput = $(this).val();
  if (validateEmail(emailInput)) {
    $("#ContactForm-email-error").html(" ");
    $("#submitBtn2").removeClass("disable")
  } else {
    $("#ContactForm-email-error").html(main_error);
    $("#submitBtn2").addClass("disable")
  }
});
$("#submitBtn2").on("click", function(e) {
  e.preventDefault(e);
  if (validateEmail(emailInput)) {
   $("#ContactForm-email-error").html(" ");
    $(this).removeClass("disable")
  } else {
    $(this).addClass("disable")
    $("#ContactForm-email-error").html(main_error);
    return false;
  }
}); 

function validateEmail(email) {
  var pattern = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
  return $.trim(email).match(pattern) ? true : false;
}

/* ======================  Colelction Page Back To Top ========================= */

$(document).ready(function(){ 
    $(window).scroll(function(){ 
        if ($(this).scrollTop() > 100) { 
            $('#scroll-top').fadeIn(); 
        } else { 
            $('#scroll-top').fadeOut(); 
        } 
    }); 
    $('#scroll-top').click(function(){ 
        $("html, body").animate({ scrollTop: 0 }, 600); 
        return false; 
    });
});



var productGrid = document.getElementById('product-grid');
if (productGrid) {
  var gridItems = productGrid.querySelectorAll('.grid__item');
  var gridItemsLength = gridItems.length;
  console.log('Number of elements with class "grid__item":', gridItemsLength);
}

$(document).on("click", ".js-load-more", function () {
  var $this = $(this),
    currentPage = parseInt($('[data-this-page]').val()),
    datacollurl = $('[data-coll-url]').val();
  var nextUrl = $('[data-next-link]').val();
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      var totalPagesElement = $(responseHTML).find('.total_page').val();
      console.log("totalPagesElement",totalPagesElement)

      $('[data-next-link]').val(datacollurl + "?page=" + next_coll);
      $('[data-this-page]').val(current_page_new);

      $('#product-grid').append($(responseHTML).find('#product-grid').html());

      var gridItemsLength = $('#product-grid .grid__item').length;
      var collection_count_main = document.getElementById('collection_count_item');
      var AppendHTML = `<span>SHOWING ${gridItemsLength} / ${totalPagesElement}</span>`;
      collection_count_main.innerHTML = AppendHTML;
    }
  });
});
var collection_count_main = document.getElementById('collection_count_item')
if (collection_count_main) {
    var totalPages = parseInt($('.total_page').val());
    var currentPage = parseInt($('[data-this-page]').val());
    var AppendHTML = `
            <span>SHOWING ${gridItemsLength} / ${totalPages}</span>
         `
     collection_count_main.innerHTML = AppendHTML;
}

/* ======================  change input ========================= */

  var variant_val ="";
  var  main_vart = "";
  var  optionvar = "";
  function changes_event(change) {
    var taskArray = [];
    $(change).parents('.hover_content').find('.product-form__input').each(function(e){
      taskArray += $(this).find('input[type=radio]:checked').val() + ' / ' ;
      optionArray = taskArray.slice(0,-3);
      console.log("optionArray",optionArray)
    });
    $(change).parents('.hover_content').find('.select__select option').each(function(e){
        variant_val = $(this).text();
      if(variant_val == optionArray){
        main_vart = $(this).val();
        optionvar = $(this).text();
      }
    });
    $(change).parents('.hover_content').find(".add_to_cart").attr("data-variantid",main_vart);
  }



var color_name = $(".size-color-swatch input[type=radio]:checked").val();
var match_variant = $(".form__label.only_color").text();
if (match_variant == 'Colour' || match_variant == "Color" ) {
  $('.color_get_item').text(color_name);
}

$(".product-form__input input[type=radio]").change(function(change){
   changes_event(this);
   color_name = $(".size-color-swatch input[type=radio]:checked").val();
   if (match_variant == 'Colour' || match_variant == "Color" ) {
    $('.color_get_item').text(color_name);
  }
 });
 
setTimeout(function(){
  document.querySelectorAll('.grid__items .add_to_carts').forEach(function($ps_this, $idx){
    $ps_this.addEventListener('click', function(event){
      var variantQty = this.closest(".hover-efects").querySelector(".quantity__input").value;
      event.preventDefault(), event.stopImmediatePropagation();
      if (variantQty > 0 ){
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({id:this.dataset.variantid, quantity:parseInt(variantQty), sections:document.querySelector('cart-drawer').getSectionsToRender().map((section) => section.id), sections_url:window.location.pathname}),
      }).then((response) => response.json()).then((cart_response) => {
        const quickAddModal = document.querySelector('quick-add-modal');
        if(quickAddModal){
          document.body.addEventListener('modalClosed', () => {
            setTimeout(() => {
              document.querySelector('cart-drawer').renderContents(cart_response);
            });
          }, {once: true});
          quickAddModal.hide(true);
        } else{
          document.querySelector('cart-drawer').renderContents(cart_response);
        }
        if(document.querySelector('cart-drawer') && document.querySelector('cart-drawer').classList.contains('is-empty')) document.querySelector('cart-drawer').classList.remove('is-empty');
      }).catch((error) => {
        console.error('Error: ', error);
      });
      }
    });
  });
}, 3000);


$(".first_item_event").on("click",function () {
  $(this).parents(".main_drawer_item").siblings(".menu_show").removeClass("menu_show")
  if($(this).parents(".first_item_menu").hasClass("menu_show")){
    $(this).parents(".first_item_menu").removeClass("menu_show")
  }else{
    $(this).parents(".first_item_menu").addClass("menu_show");
  }
});

$(".second_item_sub").on("click",function () {
  $(this).parents(".menu-drawer__inner-submenu li").siblings(".menu_sub_item").removeClass("menu_sub_item")
  if($(this).parents(".menu-drawer__inner-submenu li").hasClass("menu_sub_item")){
    $(this).parents(".menu-drawer__inner-submenu li").addClass("menu_sub_item");
  }else{
    $(this).parents(".menu-drawer__inner-submenu li").addClass("menu_sub_item");
  }
});

$(".tab-title-disc h4").on("click",function () {
  $(this).parents(".tab-title-disc").siblings(".toggle_menu").removeClass("toggle_menu")
  if($(this).parents(".tab-title-disc").hasClass("toggle_menu")){
    $(this).parents(".tab-title-disc").removeClass("toggle_menu")
  }else{
    $(this).parents(".tab-title-disc").addClass("toggle_menu");
  }
});

$(".panel").on("click",function () {
  $(this).siblings(".show_bg").removeClass("show_bg")
  $(this).toggleClass("show_bg");
})

/* ======================  for border start ========================= */


var facets__list = document.querySelectorAll('.facets__item');
facets__list.forEach(function(hov){
    hov.addEventListener("click",function(eve){
    setTimeout(() => {
        let recently_load_item = document.querySelectorAll('.recently-viewed-grid .product-listing_main_li').length;
        if(recently_load_item  <= 0){
          document.querySelector('.footer_top_content').classList.remove("remove_border_none");
          document.querySelector('.product-grid-container').style.paddingBottom = "30px";
        }else{
          document.querySelector('.product-grid-container').classList.add("border_bottom_load");
        }
      }, 200);
    });
});
/* ======================  for border end ========================= */


if($(window).innerWidth() < 749) {
  $('.product__media-list').slick({
      dots: true,
      arrows:false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
}


new Swiper('.banner_swiper', {
    loop: true,
    freeMode: true,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    slidesPerView: 1,
    paginationClickable: true,
    spaceBetween: 0,
    breakpoints: {
        1920: {
            slidesPerView: 1
        },
        1028: {
            slidesPerView: 1
        },
        480: {
            slidesPerView: 1
        }
    },
    autoplay: 
    {
      delay: 5000,
    },
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable:'true'
  },
});
document.querySelectorAll(".product_variant").forEach(function (e) {
  e.addEventListener("click", function () {
    var dataId = e.closest(".color_inner");
    const allSiblings = Array.from(dataId.parentElement.children);
    allSiblings.forEach((sibling) => {
      sibling.classList.remove("active_color");
    });
    dataId.style.border = " 0.5px solid #000000;";
    dataId.classList.add("active_color");
    var dataSrc = e.getAttribute("data-image");
    var dataParent = e.closest(".hover_content");
    var dataImgpar = dataParent.previousElementSibling;
    var dataImg = dataImgpar.querySelector(".product-item-image");
    dataImg.srcset = "" + dataSrc + "";
  });
});

/* ======================  Customer order back click  start ========================= */

$(document).ready(function(){
  var url_get = "";
  var get_account_url = "";
  $(".return-order-tab").click(function(){
    url_get = window.location.pathname.slice(1 , 8)
    localStorage.setItem('set_account_url', url_get);
  });
  $(window).on("load" , function(){
    get_account_url = localStorage.getItem('set_account_url')
    if (get_account_url) {
      $("#two-tab").trigger("click");
    }
  });
  $("#one-tab,#three-tab,#four-tab").click(function(){
    localStorage.removeItem("set_account_url");
  });
});
/* ======================  Customer order back click end ========================= */

$(document).ready(function(){
  $(".facet-filters__label").click(function(){
    $(this).toggleClass("active");
  });
});


$(".add_to_cart").on("click",function(e){
  e.preventDefault();
  var variantID = $(this).attr("data-variantid");
  var variantQty = $(this).parents(".product-block__inner").find(".select-on-focus").val();
  $(".add_to_cart[data-variantid="+ variantID +"]").html('Adding to cart...');
  setTimeout(function(){ 
      $(".add_to_cart[data-variantid="+ variantID +"]").html('Add to Cart <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">'+ '<path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="#000"></path>'+'</svg>')
  }, 1000);
});

/* ======================  filter  and sort by click start ========================= */
$("#fectfilter").on("click",function(e) {
   $(this).siblings().removeClass("active");
  if($("#FacetsWrapperDesktop").hasClass("active_toggle")){
    $("#FacetsWrapperDesktop").removeClass("active_toggle");
  }else{
     $("#FacetsWrapperDesktop").addClass("active_toggle");
  }
  $("#SortingWrapperDesktop").removeClass("active_toggle");
});
$("#fectsorting").on("click",function(e) {
  $(this).siblings().removeClass("active");
  if($("#SortingWrapperDesktop").hasClass("active_toggle")){
    $("#SortingWrapperDesktop").removeClass("active_toggle");
  }else{
     $("#SortingWrapperDesktop").addClass("active_toggle");
  }
  $("#FacetsWrapperDesktop").removeClass("active_toggle");
});
/* ======================  filter  and sort by click end ========================= */

let items = document.querySelector(".header__inline-menu").querySelectorAll(".list-menu details");
items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
  });
  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
    // document.querySelector(".mega-menulist").style.display = "grid";    
  });
});















